import http from "@/service";
import type { CommonList } from "@/types";
import type { ParamManageItem } from "@/types/system/param";

const api = {
  getParamList: "/pac-system/param/list",
  addParamItem: "/pac-system/param/save",
  deleteParamItem: "/pac-system/param/remove",
  editParamItem: "/pac-system/param/update",
  exportParamList: "/pac-system/param/export"
};

export function getParamList(params: any) {
  return http.get<CommonList<ParamManageItem>>(api.getParamList, {
    params
  });
}

export function addParamItem(params: any) {
  return http.post(api.addParamItem, params);
}

export function deleteParamItem(ids: string) {
  return http.delete(api.deleteParamItem, null, { params: { ids } });
}

export function editParamItem(params: any) {
  return http.put(api.editParamItem, params);
}

export function exportParamList(params?: any) {
  return http.post(api.exportParamList, params, {
    responseType: "blob"
  });
}
